/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotEqualFilesize: core.serialization.ObjectSchema<
    serializers.NotEqualFilesize.Raw,
    Truvity.NotEqualFilesize
> = core.serialization.object({
    value: core.serialization.number(),
});

export declare namespace NotEqualFilesize {
    export interface Raw {
        value: number;
    }
}
